import React, { useCallback, useState } from "react";
import { Bell, X } from "lucide-react";
import EventKeywordField from "./EventKeywordField";
import EventNameField from "./EventNameField";
import { usePopupLifecycle } from "../../view/popup/usePopupLifecycle";

function CreateEventPopup({ eventKeyword, closePopup, confirm }) {

    const [name, setName] = useState('');

    const handleClose = useCallback(() => closePopup(), [closePopup]);
    usePopupLifecycle(handleClose);

    const onContinueClick = () => {
        closePopup();
        confirm(name);
    };

    return (
        <div className="oct-shared-popup" role="dialog" aria-modal="true" aria-labelledby="oct-create-event-title">
            <div className="oct-shared-popup__backdrop" onClick={handleClose} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--compact" onClick={(event) => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <Bell size={18} />
                        </div>
                        <div>
                            <h4 id="oct-create-event-title" className="oct-shared-popup__title">Add Event</h4>
                            <p className="oct-shared-popup__subtitle">Create a readable event name for the selected keyword.</p>
                        </div>
                    </div>

                    <button type="button" className="oct-shared-popup__close" onClick={handleClose} aria-label="Close add event popup">
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--form">
                    <EventKeywordField popup={true} disabled={true} value={eventKeyword} />
                    <EventNameField value={name} onChange={(value) => setName(value)} />
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn oct-shared-popup__btn oct-shared-popup__btn--primary"
                        disabled={!name}
                        onClick={onContinueClick}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    )

}

export default CreateEventPopup;
